import { handleError } from 'common/utils/app.utils';
import React, { MouseEventHandler, useState } from 'react';
import { EDIT_CART_ACTION, getBulkEditRequest } from '../configure-plan-pricing-constant';
import { doBulkEditAction } from '../configure-plan-pricing.service';
import { contractPeriodOptions, isNLD_OR_LL } from 'common/constants/app.constants';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './contract-period.scss';
import { getContractPeriod, getTotalLinks } from './formControl.service';

type Props = {
  hidePopup: MouseEventHandler;
  records: Array<any>;
  reFetchRecords: Function;
};

export const ContractPeriod = ({ hidePopup, records, reFetchRecords }: Props) => {
  const [contractPeriod, setContractPeriod] = useState<{ displayName: string; key: string }>(getContractPeriod(records));
  const [loader, setLoader] = useState<boolean>(false);

  const saveContractPeriodHandler = () => {
    setLoader(true);
    const requestParam = getBulkEditRequest(EDIT_CART_ACTION.EDIT_CONTRACT_PERIOD, records, contractPeriod?.key);
    doBulkEditAction(requestParam).then(
      (response: any) => {
        setLoader(false);
        reFetchRecords?.();
        hidePopup?.(false as any);
      },
      (err: any) => {
        setLoader(false);
        handleError(err);
      }
    );
  };

  const contractPeriodHandler = (value: { displayName: string; key: string }) => {
    setContractPeriod(value);
  };

  const getMessage = () => {
    if (isNLD_OR_LL()) {
      return (
        <p className="contract-message">
          <span>{getTotalLinks(records)} selected links</span> will be updated as per the contract period selected below. Are you sure you want to proceed?
        </p>
      );
    }

    return (
      <p className="contract-message">
        <span>{getTotalLinks(records)} selected links</span> will be updated as per the contract period selected below. Please note that the contract period for secondary link will
        remain same as the primary link.
      </p>
    );
  };

  return (
    <div className="drawerSection">
      <div className="popup-section cancelOrder contractPeriod">
        <h2 className="cancel-head">Change Contract Period</h2>
        {getMessage()}
        <div className="row">
          <div className="flg-lg-5 flg-sm-12">
            <Select
              placeholder="Contract period"
              value={contractPeriod}
              onChange={contractPeriodHandler}
              options={contractPeriodOptions}
              required
              touched
              label="Contract period"
            />
          </div>
        </div>

        <div className="characters">&nbsp;</div>
        <div className="buttonSection">
          <Button type="button" buttonClass="btn" variant="outlinebtn" onClick={hidePopup}>
            Cancel
          </Button>
          <Button type="button" disabled={loader} onClick={saveContractPeriodHandler}>
            Change
            {loader && <span className="loading_icon"></span>}
          </Button>
        </div>
      </div>
    </div>
  );
};
